import { useMediaQuery } from '~/hooks/useMediaQuery';
import { DesktopLayout } from './DesktopLayout';
import { TabletLayout } from './TabletLayout';
import { MobileLayout } from './MobileLayout';
import { useApplication } from '../../../context/ApplicationProvider';
import { BreadcrumbItem } from '../types';

export const ProgramEditLayout = () => {
  const { isUltraWide, isWide, isNormal, isNarrow, isUltraNarrow, isMobile } = useMediaQuery();
  const { application } = useApplication();
  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/applications',
      label: 'Applications',
    },
    {
      href: `/applications/${application.id}`,
      label: `Application Details ${application.humanReadableId}`,
    },
    {
      href: `/applications/${application.id}/program-edit`,
      label: 'Change Primary Program Intake',
    },
  ] as BreadcrumbItem[];

  if (isUltraWide || isWide || isNormal) {
    return <DesktopLayout breadcrumbItems={breadcrumbItems} />;
  }

  if (isNarrow || isUltraNarrow) {
    return <TabletLayout breadcrumbItems={breadcrumbItems} />;
  }

  if (isMobile) {
    return <MobileLayout breadcrumbItems={breadcrumbItems} />;
  }

  return <DesktopLayout breadcrumbItems={breadcrumbItems} />;
};
